import jwtDecode from 'jwt-decode';
import { loadState, saveState, deleteState } from '../utilities/localStorage';

const settings = loadState();
//const propertySettings = loadState();
//console.log(`settings:`, settings);

const initialState = ((token, rules_token) => ({
	setupCurrent: 0,
    isAuthenticating: false,
    token,
    rules_token,
	isAuthenticated: (token && rules_token) ? true : false,
	user: token ? jwtDecode(token) : null,
	activeProperty: (localStorage.activeProperty !== undefined && localStorage.activeProperty !== 'undefined') ? JSON.parse(localStorage.activeProperty) : null,
	properties: (localStorage.properties !== undefined) ? JSON.parse(localStorage.properties) : [],
	errorMessage: null,
	language: (settings && settings.language) || "en",
	locale: (settings && settings.locale) || "en-US",
	timezone: (settings && settings.timezone) || "Europe/Athens",
	isSetup: false
}))(localStorage.authToken, localStorage.rulesToken);

function getActiveProperty(properties) {
	const newproperties = properties;
	//const profile = jwtDecode(token);
	localStorage.properties = JSON.stringify(newproperties);
	const property = newproperties[0];
	localStorage.activeProperty = JSON.stringify(property);
	return property;
}

const reducer = (state = initialState, action = {}) => {
  //let	propertySettings = (initialState.activeProperty && initialState.activeProperty.settings) || {};
  switch (action.type) {
    case 'LOGIN_REQUEST':
        return {
            ...state,
            isAuthenticating: true,
            errorMessage: null
        }
		case 'LOGIN_FAILURE':
        return {
            ...state,
            isAuthenticating: false,
            errorMessage: (action.error && action.error.response && action.error.response.data.message) || 'Server Error'
        }
    case 'LOGIN_SUCCESS':
    
    	//console.log(action.payload.data);
    	const properties = (action.payload.data.data && action.payload.data.data.properties) || [];
    	const settings = (action.payload.data.data && action.payload.data.data.settings) || {};
    	//console.log(`settings:`, settings);
    	const token = action.payload.data.token;
    	const rules_token = action.payload.data.rules_token;
    	const language = (action.payload.data.data && action.payload.data.data.language) || null;
		const locale_id = (action.payload.data.data && action.payload.data.data.locale_id) || null;
		const timezone = (action.payload.data.data && action.payload.data.data.settings && action.payload.data.data.settings.timezone) || null;
    	//console.log(`locale_id:`, locale_id);
		const activeProperty = getActiveProperty(properties);
		//propertySettings = (activeProperty && activeProperty.settings) || {};

    	//const activeProperty = getActiveProperty(token);
		localStorage.authToken = token;
		localStorage.rulesToken = rules_token;
		saveState(settings, true);
		//saveState(propertySettings);
		
		return {
			...state,
			isAuthenticating: false,
			isAuthenticated: true,
            user: jwtDecode(token),
            token,
            rules_token,
			activeProperty: activeProperty,
			properties: properties,
			errorMessage: null,
			language:language,
			locale: locale_id,
            timezone: timezone,
            settings,
			isSetup: false//(activeProperty.setup_completed !== undefined) ? !Boolean(activeProperty.setup_completed) : true,
		}
    case 'LOGOUT':
    
      //localStorage.removeItem("authToken");
      //localStorage.removeItem("activeProperty");
      localStorage.removeItem("properties");
      localStorage.removeItem("socket_id");
      deleteState();

      return {
	    ...state,
        isAuthenticating: false,
        isAuthenticated: false,
        user: null,
        token: null,
        rules_token: null,
        activeProperty: null,
        properties: [],
        errorMessage: null
      }
    case 'SWITCH_LOCALE':
    	const newLanguage = action.payload.locale.language;
        const newLocale = action.payload.locale.locale;
    	return {
		    ...state,
	        language:newLanguage,
			locale:newLocale,
		}
	case 'SWITCH_TIMEZONE':
    	const newTimezone = action.payload.timezone;
    	return {
		    ...state,
				timezone:newTimezone,
	    }
	case 'CREATE_PROPERTY':
    	return {
		    ...state,
	        isSetup: true,
			activeProperty:null
	    }
	case 'ACTIVE_PROPERTY':
		localStorage.activeProperty = JSON.stringify(action.payload);
		//propertySettings = (action.payload && action.payload.settings) || {};
		//saveState(propertySettings);

    	return {
		    ...state,
			activeProperty:action.payload
	    }
    default:
      return state
  }
}

export default reducer